import esuIcon from '@comicrelief/component-library/src/components/Organisms/Header/assets/Post.svg';
import CloseIcon from './icon--close.svg';

const HeaderIcons = {
  email: {
    icon: esuIcon,
    title: 'Newsletter'
  },
  close: {
    icon: CloseIcon,
    title: 'Close email sign-up'
  }
};

export default HeaderIcons;
